/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { webpageState } from "./webpage.state";

const webpageSlice = createSlice({
    name: "webpage",
    initialState: webpageState,
    reducers: {
        setWebpage (state, action) {
            state.webpage = action.payload;
        },
        setModel (state, action) {
            state.model = action.payload;
        },
        setBannerImage (state, action) {
            state.bannerImage = action.payload;
        }
    }
});

export const webpageReducer = webpageSlice.reducer;

export const {
    setWebpage,
    setModel,
    setBannerImage,
} = webpageSlice.actions;
